import React, { ReactNode, createContext, useContext, useState } from 'react';

type HistoryFields = {
  pageCount: number;
  setPageCount: (pageCount: number) => void;
  layoutRedirect: boolean;
  setLayoutRedirect: (layoutRedirect: boolean) => void;
};

export const HistoryFieldsContext = createContext<HistoryFields>({
  pageCount: 0,
  setPageCount: () => {},
  layoutRedirect: true,
  setLayoutRedirect: () => {},
});

export const HistoryFieldsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [pageCount, setPageCount] = useState<number>(0);
  const [layoutRedirect, setLayoutRedirect] = useState<boolean>(true);

  return (
    <HistoryFieldsContext.Provider
      value={{
        pageCount,
        setPageCount,
        layoutRedirect,
        setLayoutRedirect,
      }}
    >
      {children}
    </HistoryFieldsContext.Provider>
  );
};

export const useHistoryFields = (): HistoryFields => useContext(HistoryFieldsContext);
